// タブ
const tabList = document.querySelectorAll(".tab-list__item");
// タブコンテンツ
const tabContent = document.querySelectorAll(".tab-contents__item");

// タブにhover時の動作を追加する
tabList.forEach((tab, index) => {
  tab.addEventListener("mouseenter", () => {
    // activeクラスを削除
    document.querySelector(".tab-list__item.active").classList.remove("active");
    tab.classList.add("active");

    // show クラスを削除
    document.querySelector(".tab-contents__item.show").classList.remove("show");

    // タブのインデックスから同じインデックスのコンテンツにshowクラスを付与する
    tabContent[index].classList.add("show");
  });
});


window.addEventListener('DOMContentLoaded',function(){
  let imageBtn = document.getElementsByClassName('js-image');
  let imageMain = document.getElementById('js-image-target');
  for(let i = 0; i < imageBtn.length; i++){
    imageBtn[i].addEventListener('click',function(){
      let imageStack = this.firstElementChild.getAttribute('src');
      imageMain.setAttribute('src',imageStack)
    },false);
  }
});